<template>
<div class="cost-container">
  <div class="expense-wrp">
    <el-table
        :data="tableData"
        border
        style="width: 100%">
      <el-table-column
      label="OPERATING EXPENSES">
        <template slot-scope="scope">
          <div class="normal">{{scope.row.attributeName}}</div>
        </template>
      </el-table-column>
      <el-table-column
      label="EXPENSES TYPES">
        <template slot-scope="scope">
          <div class="normal" v-if="scope.row.sort === 0">Fixed OH</div>
          <div class="normal" v-if="scope.row.sort === 1">Variable OH</div>
        </template>
      </el-table-column>
      <template slot="empty">
        <i v-if="loading" class="el-icon-loading" style="font-size:20px"></i>
        <div v-else>-</div>
      </template>
    </el-table>
  </div>
</div>
</template>

<script>
import api from '../../../api/account'
import pageination from '../../../components/common/pageination'

export default {
  data () {
    return {
      loading: true,
      tableData: [],
      page: 1,
      pagesize: 10,
      totalRecord: 0
    }
  },
  created() {
    if (!this.$route.params.id) {
      return
    }
    api.expense({
      params: {
        venueId: parseInt(this.$route.params.id)
      },
      callback: this.callback
    })
  },
  methods: {
    callback (res) {
      var that = this
      this.loading = false
      if(res.data.code == 0){
        that.tableData = res.data.data
        // that.totalRecord = res.data.data.total
      } else{
        Utils.alert('', res.data.message, 'error')
      }
    },
    pageChange (page) {
      this.page = page
      this.tableData = []
      this.loading = true
      api.expense({
        params: {
          venueId: parseInt(this.$route.params.id)
        },
        callback: this.callback
      })
    }
  },
  components: {
    pageination
  }
}
</script>

<style lang="scss" scoped>
.cost-container{
  width: 100%;
  background: #2B3444;
  box-sizing: border-box;
  padding: 50px 30px 30px 30px;
}
.expense-wrp{
  width: 100%;
  background: #151C27;
  padding-bottom: 50px;
  h2{
    line-height: 70px;
    width: 100%;
    box-sizing: border-box;
    padding-left: 30px;
    font-size:20px;
    font-weight:600;
    color: #fff;
  }
  .normal{
    font-size: 18px;
  }
  .bold-row{
    font-weight: 600;
    font-size: 20px;
    i{
      width: 28px;
      height: 28px;
      background-repeat: no-repeat;
      background-position: center center;
      background-size: contain;
      background-image: url('../../../assets/t.png');
      cursor: pointer;
      float: right;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/account/expense/index.vue